import { sandboxBaseGameQuery } from "/app/src/routes/{-$locale}/changelog/$id.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/changelog/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { dehydrate } from "@tanstack/react-query";
import { httpClient } from "@/lib/http-client";
import i18n from "@/lib/i18n";
type ChangeResponse = OfferHit | ItemHit | AssetHit | Hit;
interface DefaultHit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
interface Metadata {
  changes: Change[];
  contextId: string;
  contextType: string;
  context: SingleOffer | SingleItem | null;
}
interface Change {
  changeType: "insert" | "update" | "delete";
  field: string;
  newValue: unknown;
  oldValue: unknown;
}
interface OfferHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "offer";
    context: SingleOffer;
  };
}
interface ItemHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "item";
    context: SingleItem;
  };
}
interface AssetHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "asset";
    context: SingleItem;
  };
}
interface Hit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
export const Route = createFileRoute("/{-$locale}/changelog/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      queryClient
    } = context;
    const {
      id
    } = params;
    const data = await queryClient.ensureQueryData({
      queryKey: ["changelog", id],
      queryFn: () => httpClient.get<ChangeResponse>(`/changelist/${id}`).catch(() => null)
    });
    if (data?.metadata.context?.namespace) {
      await queryClient.prefetchQuery(sandboxBaseGameQuery(data.metadata.context.namespace));
    }
    return {
      dehydratedState: dehydrate(queryClient),
      id
    };
  },
  head() {
    return {
      meta: [{
        title: i18n.t("changelog.detail.meta.title")
      }]
    };
  }
});